import { RawConfig } from './raw-config.model';

export class Config {
    allowedDaysInThePast: number;
    allowedVideoRequestLengthMinutes: number;
    allowedFreeDownloadVideoRequestLengthMinutes: number;
    apiEndpoint: string;
    apiRoot: string;
    applicationInsightsInstrumentationKey: string;
    bingMapsApiKey: string;
    clientId: string;
    dateFormatLong: string;
    dateFormatMedium: string;
    defaultAddress: string;
    defaultLatitude: number;
    defaultLongitude: number;
    defaultSite: string;
    defaultVideoRequestLengthMinutes: number;
    environment: string;
    momentDateAndTimeFormatTitle: string;
    momentDateFormatLong: string;
    momentDateFormatMedium: string;
    momentTimeFormatLong: string;
    momentTimeFormatMedium: string;
    productName: string;
    supportEmails: string;
    tenant: string;
    validAudience: string;
    version: string;
    resource: string;
    authority: string;

    constructor(raw: RawConfig) {
        this.allowedDaysInThePast = parseInt(raw.allowedDaysInThePast, 10);
        this.allowedVideoRequestLengthMinutes = parseInt(raw.allowedVideoRequestLengthMinutes, 10);
        this.allowedFreeDownloadVideoRequestLengthMinutes = parseInt(raw.allowedFreeDownloadVideoRequestLengthMinutes, 10);
        this.apiEndpoint = raw.apiEndpoint;
        this.apiRoot = raw.apiRoot;
        this.applicationInsightsInstrumentationKey = raw.applicationInsightsInstrumentationKey;
        this.clientId = raw.clientId;
        this.dateFormatLong = raw.dateFormatLong;
        this.dateFormatMedium = raw.dateFormatMedium;
        this.defaultAddress = raw.defaultAddress;
        this.defaultLatitude = parseFloat(raw.defaultLatitude);
        this.defaultLongitude = parseFloat(raw.defaultLongitude);
        this.defaultSite = raw.defaultSite;
        this.defaultVideoRequestLengthMinutes = parseInt(raw.defaultVideoRequestLengthMinutes, 10);
        this.environment = raw.environment;
        this.momentDateAndTimeFormatTitle = raw.momentDateAndTimeFormatTitle;
        this.momentDateFormatLong = raw.momentDateFormatLong;
        this.momentDateFormatMedium = raw.momentDateFormatMedium;
        this.momentTimeFormatLong = raw.momentTimeFormatLong;
        this.momentTimeFormatMedium = raw.momentTimeFormatMedium;
        this.productName = raw.productName;
        this.supportEmails = raw.supportEmails;
        this.tenant = raw.tenant;
        this.validAudience = raw.validAudience;
        this.version = raw.version;
        this.bingMapsApiKey = raw.bingMapsApiKey;
        this.resource = raw.resource;
        this.authority = raw.authority;
    }
}
